import { zodSinEval } from '@pasos/schemas/sin-eval';

/**
 * Lo primero que importa `main.tsx`: Zod sin su prueba de `eval`, antes de que
 * ningún módulo construya un esquema (P-114, `packages/schemas/src/sin-eval.ts`). La CSP
 * no se toca: sigue sin `unsafe-eval`.
 */
zodSinEval();
